import { PerspectiveCamera } from "three"
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls.js"
import * as THREE from "three/webgpu"
import { FolderApi } from "tweakpane"

import Experience from "../index"

export default class Renderer {
  experience: Experience
  debug!: Experience["debug"]
  sizes!: Experience["sizes"]
  instance!: THREE.WebGPURenderer
  renderTarget!: THREE.RenderTarget
  controls: OrbitControls | undefined
  controlsCamera: PerspectiveCamera | undefined
  debugFolder: FolderApi | undefined

  constructor() {
    this.experience = Experience.getInstance()
    this.sizes = this.experience.sizes
    this.debug = this.experience.debug

    if (this.debug.active && this.debug.ui) {
      this.debugFolder = this.debug.ui.addFolder({
        title: "📸 Renderer",
        expanded: false,
      })

      const logInfo = this.debugFolder.addButton({ title: "Log Info" })
      logInfo.on("click", () => {
        console.log("Rendered info")
        console.log("Renderer Info", this.instance.info)
        console.log("Renderer", this.instance)
        console.groupEnd()
      })
    }

    this.setInstance()
  }

  setInstance() {
    this.instance = new THREE.WebGPURenderer({
      antialias: window.devicePixelRatio < 2,
    })

    // this.instance.setPixelRatio(window.devicePixelRatio)
    this.instance.setPixelRatio(1)
    this.instance.setSize(this.sizes.width, this.sizes.height)
    this.instance.setAnimationLoop(this.update.bind(this))
    this.instance.domElement.id = "webgpu-renderer"
    document.body.appendChild(this.instance.domElement)

    this.instance.toneMapping = THREE.ACESFilmicToneMapping
  }

  update() {
    // https://discourse.threejs.org/t/render-info-of-effectcomposer-show-no-real-values/21221/3
    // if (this.debug.active && this.debug.ui) {
    //   this.instance.info.reset()
    // }

    if (this.controls) {
      this.controls.update()
    }

    this.experience.update()
  }

  resize() {
    this.instance.setSize(this.sizes.width, this.sizes.height)
    this.instance.setPixelRatio(1)
  }
}
